import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


export default new Router({
  routes: [{
    path: '/',
    name: 'Admin',
    component: () => import('@/views/Admin/index'),
    // name: 'Login',
    // component: () => import('@/views/Login/index'),
    children: [{
        path: '/',
        redirect: '/dashboard'
      },
      {
        path: '/dashBoard',
        name: '仪表盘',
        // 路由懒加载
        component: () => import('@/views/DashBoard/index')
      },
      {
        path: '/carts',
        name: '商城订单',
        // 路由懒加载
        component: () => import('@/views/Carts/index')
      },
      {
        path: '/cartdetail',
        name: '订单详情',
        // 路由懒加载
        component: () => import('@/views/Carts/cartdetail')
      },
      {
        path: '/examine',
        name: '订单审核',
        // 路由懒加载
        component: () => import('@/views/Carts/examine')
      },
      {
        path: '/baocan',
        name: '报餐订单',
        // 路由懒加载
        component: () => import('@/views/Baocan/index')
      },
      {
        path: '/setting',
        name: '账户设置',
        // 路由懒加载
        component: () => import('@/views/Setting/index')
      }
    ]
  },
    {
      path: '/Login',
      name: '登录',
      component: () => import('@/views/Login/index')
    },
  ]
})
// import Vue from 'vue'
// import Router from 'vue-router'
// import Login from '@/views/Login/index'
// import dashBoard from '@/views/DashBoard/index'
// import carts from '@/views/Carts/index'
// import cartdetail from '@/views/Carts/cartdetail'
// import baocan from '@/views/Baocan/index'
// import setting from '@/views/Setting/index'
//
// Vue.use(Router)
//
// export default new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'Login',
//       component: Login
//     },
//     {
//       path: '/dashBoard',
//       component: dashBoard
//     },
//     {
//       path: '/carts',
//       component: carts
//     },
//     {
//       path: '/cartdetail',
//       component: cartdetail
//     },
//     {
//       path: '/baocan',
//       component: baocan
//     },
//     {
//       path: '/setting',
//       component: setting
//     }
//   ]
// })




// WEBPACK FOOTER //
// ./src/router/index.js